import { render, staticRenderFns } from "./ProActionPlanFilter.vue?vue&type=template&id=8645ce3e&"
import script from "./ProActionPlanFilter.vue?vue&type=script&lang=ts&"
export * from "./ProActionPlanFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports